const LinkIcon = ({ className = '' }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      className={className}
    >
      <path
        d='M10 14L14 10M4.5 19.5C3.83805 18.8364 3.46631 17.9373 3.46631 17C3.46631 16.0627 3.83805 15.1636 4.5 14.5L7 12C7.66362 11.338 8.56268 10.9663 9.5 10.9663C10.4373 10.9663 11.3364 11.338 12 12C12.6619 12.6636 13.0337 13.5627 13.0337 14.5C13.0337 15.4373 12.6619 16.3364 12 17L9.5 19.5C8.83638 20.1619 7.93732 20.5337 7 20.5337C6.06268 20.5337 5.16362 20.1619 4.5 19.5ZM17.5 11.5L20 9C20.6619 8.33638 21.0337 7.43732 21.0337 6.5C21.0337 5.56268 20.6619 4.66362 20 4V4C19.3364 3.33805 18.4373 2.96631 17.5 2.96631C16.5627 2.96631 15.6636 3.33805 15 4L12.5 6.5C11.838 7.16362 11.4663 8.06268 11.4663 9C11.4663 9.93732 11.838 10.8364 12.5 11.5V11.5C13.1636 12.1619 14.0627 12.5337 15 12.5337C15.9373 12.5337 16.8364 12.1619 17.5 11.5Z'
        stroke='#1E2B55'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default LinkIcon;
